export enum RingPositions {
    left = 'left',
    right = 'right'
}export enum RingPositions {
    left = 'left',
    right = 'right'
}